import React, { createContext, useContext } from 'react';
import useDarkMode from '../hooks/useDarkMode';

/**
 * Контекст темы для управления темной/светлой темой
 */
const ThemeContext = createContext();

/**
 * Провайдер темы для обертки приложения
 * 
 * @param {ReactNode} children - Дочерние компоненты
 */
export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useDarkMode();
  
  /**
   * Функция для переключения темы
   */
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };
  
  const value = {
    darkMode,
    toggleDarkMode
  };
  
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

/**
 * Хук для использования темы в компонентах
 * 
 * @returns {Object} { darkMode, toggleDarkMode } - Состояние темы и функция переключения
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
};

export default ThemeContext;